<div class="list-wrapper d-flex flex-wrap">
  <ng-container *ngFor="let company of companyList; let i = index">
    <app-company-card [company]="company" class="card-company"></app-company-card>
    <!-- <div *ngIf="i == 3">
      <app-feeds-marketing-card></app-feeds-marketing-card>
    </div> -->
  </ng-container>
</div>
